<template>
  <!--我的訂單-->
  <div>
    <div class="loadingInf">
      <span>
        {{ $t('mall_order.all_order') }}<!-- 全部訂單 -->
      </span>
      <span v-if="orderDataList" class="total">
        {{ $t('mall_order.have') }} {{ orderDataList.length }} {{ $t('mall_order.items_order') }}
      </span>
    </div>
    <div v-if="orderDataList && orderDataList.length>0 " class="scrollBox">
      <div class="selfOrder clear" v-for="item in orderDataList" :key="item.id">
        <router-link :to="{name:'OrderDetail',query:{id:item.order_purchase_products[0].order_purchase_id}}">
          <div class="timeBox">
            <div class="date">{{ item.created_at }}</div> <!--訂單創建時間-->
            <div class="finish">
              <span>{{ item.order_status }}</span>  <!--訂單狀態-->
              <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
            </div>
          </div>

          <div class="orderList clear">
            <div style="margin-bottom: 20px;" v-for="product in item.order_purchase_products" :key="product.id">
              <div class="orderImg">
                <img :src="imgUrl + product.product_model.path" alt="">
              </div>
              <div class="orderDetail">
                <div class="name">
                  <span>{{ product.product_model.default_name}}</span> <!--產品名稱-->
                  <!--                  <span class="count">1px</span>-->
                </div>
                <div class="orderRight">
                  <div class="orderInf">
                    <div>
                      <span>
                       {{ $t('mall_detail.color') }} : <!-- 顏色 -->
                      </span>
                      <span>{{ product.product_model.color_photo[0].color.name }}</span>
                    </div>
                    <div>
                      <span>
                       {{ $t('mall_detail.size') }} : <!-- 尺寸 -->
                      </span>
                      <span>{{
                          product.product_size === '0'
                            ? $t('mall_detail.free_size')
                            : product.product_size + $t('mall_detail.free_num')
                        }}</span>
                    </div>
                  </div>
                  <div class="price">${{ product.total|PriceFormat }}</div>
                </div>
              </div>
            </div>
            <div class="totalAmount">
              {{ $t('mall_order.have') }} {{ item.product_number }} {{ $t('mall_order.items_product') }}
              <span>{{$t('mall_detail.total')}}：<!-- 合計 --></span>
              <span>${{ item.total|PriceFormat }}</span>
              <span v-if="item.shipping_price>0"
                    style="font-size:14px;color:rgba(122,121,119,1);">（
                {{$t('mall_order.including_postage')}}<!-- 含郵費 -->
                ${{ item.shipping_price }}
                ）</span>
            </div>
          </div>
        </router-link>
        <router-link :to="{name:'PayOrder',params:{id:item.id}}">
          <button v-show="item.is_completed==='n'" class="btn2Pay">
            {{ $t('mall_order.pay') }}<!-- 立即支付 -->
          </button>
        </router-link>
        <button v-show="item.is_completed==='n'" class="btn2Cancel" @click="cancelOrder(item.id)">
          {{ $t('mall_order.cancel') }}<!-- 取消訂單 -->
        </button>

      </div>
    </div>
    <div v-else style=" margin: 260px auto; text-align: center">
      <p class="text_tips">
        {{ $t('mall_order.no_more_tips') }}<!-- 您還沒有訂單，快去挑選心儀的首飾 -->
      </p>
      <router-link :to="{name:'Search',query:{type:'reco'}}">
        <button class="btn_look">
          {{ $t('mall_order.shop') }}<!-- 去選購商品 -->
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
import PriceFormat from '@/assets/js/PriceFormat';

export default {
  name: "MyOrder",
  data() {
    return {
      imgUrl: baseUrl.imgUrl,
      orderDataList: null
    };
  },
  filters: {
    PriceFormat(val) {
      return PriceFormat(val);
    }
  },
  methods: {
    goToDetail(index) {
    },
    //獲取訂單列表
    getOrderList() {
      this.$axios.get('mall_api/purchase_orders',{}).then(res => {
        // console.log('訂單詳情列表', res.data.data.data);
        this.orderDataList = res.data.data.data;
      });
    },
    // 取消订单
    cancelOrder(id) {
      // console.log('当前订单编号：', id);
      this.$axios.post('mall_api/trans/abort_purchase', {
        'order_purchase_id': id
      }).then(res => {
        this.$notify.success({
          title: this.$t('mall_order.order_cancel'), //'成功取消訂單'
        });
        this.getOrderList();
      })
    }
  },
  mounted() {
    // if (no_login) {
    //
    //   return
    // };
    // 登錄狀態下
    this.getOrderList();
  }
}
</script>

<style scoped>

.loadingInf {
  color: #1E1303;
  font-size: 18px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.total {
  color: #979694;
  font-size: 14px;
}

.selfOrder {
  width: 100%;
  /*height: 85%;*/
  padding: 20px;
  border: 1px solid #ddd;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 20px;
  /*position: absolute;*/
  /*overflow: scroll;*/

}

.scrollBox {
  position: relative;
  /*width: 93%;*/
  /*height: 85%;*/
  /*overflow-y: scroll;*/
}

.timeBox {
  color: #7A7977;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.finish {
  color: #BAA069;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.finish > img {
  width: 10px;
  height: 10px;
}

.orderList {
  padding-top: 10px;
  /*padding-bottom: 10px;*/
  margin-bottom: 10px;
}

.orderList > div {
  display: flex;
  flex-direction: row;
}

.orderImg {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 119px;
  height: 100px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  margin-right: 20px;

  /*-webkit-box-sizing: border-box;*/
  /*-moz-box-sizing: border-box;*/
  /*box-sizing: border-box;*/
}

.orderImg > img {
  width: 100%;
}

.orderDetail {
  color: #979694;
  font-size: 14px;
  width: 100%;
  /*margin-left: 20px;*/
  /*margin-right: 20px;*/
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
}

.name {
  color: #5B5957;
  font-size: 16px;
  padding-bottom: 10px;
}

.count {
  color: #979694;
  font-size: 14px;
}

.orderRight {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.price {
  color: #3E3C39;
  font-size: 18px;
}

.totalAmount {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  color: #7A7977;
  font-size: 14px;
}

.totalAmount > span {
  color: #3E3C39;
  font-size: 16px;
}

.totalAmount > span:nth-child(1) {
  padding-left: 20px;
}

.totalAmount > span:nth-child(2) {
  font-size: 20px;
  /*padding-right: 10px;*/
}

.btn2Pay {
  width: 112px;
  height: 40px;
  color: white;
  font-size: 16px;
  background: black;
  text-align: center;
  float: right;
  /*margin-right: 1%;*/
  margin-top: 10px;
  border: none;
}

.btn2Cancel {
  width: 112px;
  height: 40px;
  color: black;
  border: 1px solid black;
  font-size: 16px;
  background: white;
  text-align: center;
  float: right;
  margin-right: 3%;
  margin-top: 10px;
}

.text_tips {
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: black;
  letter-spacing: 2px;
}

.btn_look {
  font-size: 16px;
  width: 112px;
  height: 42px;
  background-color: #4B4946;
  color: #fff;
  text-align: center;
  margin-top: 34px;
}

</style>



// WEBPACK FOOTER //
// src/views/viewHK/MyProfile/MyOrder.vue